import GuestEditor from "../components/GuestEditor";

export default function GuestEditorPage() {
  return (
    <section className="py-10">
      <GuestEditor />
    </section>
  );
}
